import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import Socket from "./socket";
import {PersistGate} from "redux-persist/integration/react";
import {persistor, store} from "./Redux/store";

ReactDOM.render(
    <Provider store={store}>
        <Socket>
            <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
                <App/>
            </PersistGate>
        </Socket>
    </Provider>,
document.getElementById('root')
)
;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
